// extracted by mini-css-extract-plugin
module.exports = {"root":"companyInfo_root__1kEW2","outer":"companyInfo_outer__3u9iw","inner":"companyInfo_inner__3Fr7S","infoWrapper":"companyInfo_infoWrapper__3USJZ","row":"companyInfo_row__3V6z9"};